import { defineStore } from 'pinia'
import { ref } from 'vue'
import { config } from '@/config/env'

export const useCitiesStore = defineStore('cities', () => {
  const cities = ref([])

  async function fetchCities() {
    if (cities.value.length > 0) return

    try {
      const response = await fetch(`${config.apiUrl}/cities`)  // ← Manquait la parenthèse fermante
      if (response.ok) {
        const data = await response.json()
        cities.value = Array.isArray(data) ? data : []
      }
    } catch (e) {
      console.error('Erreur:', e.message)  // ← e.message (pas e. message avec espace)
    }
  }

  return { cities, fetchCities }
})
